<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-09-25 09:23:56
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-11-21 10:40:17
 -->
<!--  -->
<template>
  <div class="experienceTop">
    <el-row>
      <el-col :span="24">
        <h4><span @click="goxdindex" class="goindex">#每日心得</span><span
            v-if="experienceTop.xm">#{{experienceTop.xm}}</span></h4>
        共<span class="blue_font">{{count}}</span>条心得 &nbsp;&nbsp;&nbsp;&nbsp;
        共<span class="blue_font">{{plCount}}</span>次讨论
      </el-col>
    </el-row>
  </div>
</template>

<script>

export default {
  name: 'ExperienceTop',
  props: ['count', 'experienceTop'],
  data() {
    return {
      plCount: 0
    }
  },

  mounted() {
    this.getplCount()
  },
  methods: {
    getplCount() {
      if (!this.experienceTop.sjh) {
        this.$http.post('/fighter-lightportal-saas/tExperienceComment/query', {
          'pageNum': 1,
          'pageSize': 1
        }).then(res => {
          this.plCount = res.data.total
        }).catch(res => {
          this.$message.error(res.msg)
        })
      } else {
        let params = {}
        params.commentUser = this.experienceTop.sjh
        this.$http.get('/fighter-lightportal-saas/tExperienceComment/list', { params }).then(res => {
          this.plCount = res.data.length
        }).catch(res => {
          this.$message.error(res.msg)
        })
      }
    },
    goxdindex() {
      this.$emit('experienceTopData')
    }

  }
}
</script>

<style lang="scss" scoped>
.experienceTop {
  background-color: white;
  padding: 15px;
  box-sizing: border-box;
  h3 {
    margin: 12px 0;
  }
  h4 {
    display: inline;
    span {
      padding-right: 15px;
    }
    .goindex {
      cursor: pointer;
    }
  }
  .blue_font {
    color: #1871db;
  }
}
</style>
